import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { API_URL } from '../../../Config';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Tokentable = () => {
    const [Tokens, Settokens] = useState([]);

    const fetchToken = async () => {
        await axios.get(`${API_URL}/indexData.php?type=Fetchtokens`, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(res => {
            Settokens(res.data);
        })
    }

    useEffect(() => {
        fetchToken();
    }, [])
    return (
       
            <Box className='ranking_selector'>
                <Container maxWidth='xl'>
                    <Typography variant="h2" gutterBottom component='h2' color='#000' fontSize='45px' fontWeight='bold'>
                        Token
                    </Typography>
                    <Grid container spacing={2}> 
                        <Grid item lg={12} sm={12} md={12} xs={12}>
                            <Box marginY={3}>
                                <TableContainer component={Paper} className='cadssd'>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Token Name</TableCell>
                                                <TableCell align="center">Token Address</TableCell>
                                                <TableCell align="center"> 24 Hours</TableCell>
                                                <TableCell align="center">7 days</TableCell>
                                                <TableCell align="center">Liquidity</TableCell> 
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Tokens && Tokens.map((data, idx) => (
                                                <TableRow key={idx} >
                                                    <TableCell component="th" scope="row">
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                            <Box>
                                                                <Typography variant='h6'>
                                                                    {data.TokenName}
                                                                </Typography>
                                                            </Box>
                                                        </Box> 
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box>
                                                            <Typography variant='h6'>
                                                                {data.Tokenaddress}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box>
                                                            <Typography variant='h6'> 
                                                                {Number(data.oneday).toFixed(4)} {data.TokenName}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box>
                                                            <Typography variant='h6'> 
                                                                {Number(data.sevenday).toFixed(4)} {data.TokenName}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box>
                                                            <Typography variant='h6'>
                                                                <a target="blank" href={`https://pancake.kiemtienonline360.com/#/swap?outputCurrency=${data.Tokenaddress}`}>
                                                                    <Button variant='containt' target="blank" className='buy_buy'> Buy </Button>
                                                                </a> 
                                                            </Typography>
                                                        </Box>
                                                    </TableCell> 
                                                </TableRow>
                                            ))} 
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>  
         
    )
}

export default Tokentable;